<template>
  <div class="display">
    {{ value }}
  </div>
</template>

<script>
export default {
  name: 'FormDisplay',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: [String, Number, Object],
    formData: Object,
  },
};
</script>

<style></style>
